<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
           
            <div class="col-sm-6">
              <a routerLink="/settings/add-spare-part" class="btn btn-success pull-left" class="btn btn-success"><i
                class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i>New Spare Part</a>
            </div><!-- /.col -->
           
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Spare Parts</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
        <div class="row">
            <div class="col-md-8">
                <div class="row">
                   
                </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                  <div class="col">
                      <input type="text" class="form-control" placeholder="Type here to search" (input)="onSearchTextChange($event)">
                  </div>
              </div>
            </div>
        </div>
    </div>
    </section>

     <!--Loading Spinner-->
     <div *ngIf="isProcessing">
      <app-spinner></app-spinner>
    </div>

      <!-- /.content-header -->
    <section class="content">
      <div class="container-fluid">
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Spare Parts</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
            </div>
            <!--Success Message-->
            <div class="alert alert-success" role="alert" *ngIf="successMessage">
            {{successMessage}}
            </div>
            <table id="example1" class="table table-bordered table-hover">
              <thead>
                <tr>
                    <th>Spare Part</th>
                    <th>Created On</th>
                    <th>Updated On</th>
                    <th></th>
                </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let spart_part of spart_parts | searchSparePart: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                      <td>{{spart_part.name}}</td>
                      <td>{{spart_part.created_at | date: 'dd-MM-yyyy'}}</td>
                      <td>{{spart_part.updated_at | date: 'dd-MM-yyyy'}}</td>
                      <td>
                        <div class="dropdown">
                            <button class="btn btn-default dropdown-toggle" type="button"
                                data-toggle="dropdown">Action
                                <span class="caret"></span></button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" routerLink="/settings/edit-spare-part/{{spart_part.id}}"><i class="fa fa-edit"></i>&nbsp;Edit</a></li>
                                <li><a class="dropdown-item" href="#" (click)="deleteSparePart($event,spart_part.id)"><i class="fa fa-trash"></i>&nbsp;Delete</a></li>
                            </ul>
                        </div>
                      </td>
                  </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </section>